// Bridges axios (non-React) to React Router: navigate to session-ended once per incident.

let navigateRef = null;
let hasAnnounced = false;

export function registerSessionExpiredNavigator(navigate) {
  navigateRef = navigate;
}

export function unregisterSessionExpiredNavigator() {
  navigateRef = null;
}

/** Call after successful re-auth so the next expiry can navigate again. */
export function resetSessionExpiredGate() {
  hasAnnounced = false;
}

/**
 * Send the user to the global session-ended screen (any axios auth failure site).
 * No-ops on login/session pages or if a redirect was already triggered.
 */
export function notifySessionExpired() {
  if (typeof window === "undefined") return;
  const path = window.location.pathname;
  if (path === "/login" || path === "/session-ended") return;
  if (hasAnnounced) return;
  hasAnnounced = true;
  if (navigateRef) {
    navigateRef("/session-ended", { replace: true });
  } else {
    window.location.assign(`${window.location.origin}/session-ended`);
  }
}
